export const VERSION = '4.2.11-gogreen';
export const GIT_HASH = '4b8e0e5c9b900528aac6b51db5cbb4902ec0d111';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
